export default {
  overview: {
    logo: "YiSuCloud",
    billing: {
      header: 'Billing',
      availableCredit: 'Available Credit',
      consumptionTip: 'Cumulative Consumption This Month',
      addFunds: 'Add Funds'
    },
    products: {
      header: 'Products',
      ecc: {header: 'Elastic Cloud Computing (ECC)', introduction: 'A stable, secure, elastic, and high-performance cloud computing service'},
      bms: {
        header: 'Bare Metal Server (BMS)',
        introduction: 'It provides excellent computing performance and data security for core databases, key application systems and high performance computing.'
      },
      mysql: {
        header: 'MySQL (RDS)',
        introduction: 'It has multiple safetyprotection measures and a complete performance monitoring system, and provides professional database backup, recovery and optimization solutions.'
      },
    },
    support: {
      header: 'Support',
      guide: 'Guides and Tutorials',
      faq: 'Frequently Asked Questions',
      contact: 'Contract Us'
    },
    rechargeDialog: {

    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/overview.js